import { useEffect, useState } from "react";
import { useCountUp } from "@/lib/useCountUp";
import { Reveal } from "@/components/landing/Reveal";
import api from "@/lib/api";

function LiveNumeral({ target, prefix = "" }) {
  const [value, ref] = useCountUp(target, 1400);
  return (
    <span ref={ref} className="font-display text-[clamp(2.25rem,5vw,3.75rem)] text-amtm-text leading-none">
      {prefix}
      {value.toLocaleString("en-IN")}
    </span>
  );
}

export function LiveStatsStrip() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/public/stats").then((res) => setStats(res.data)).catch(() => {});
  }, []);

  const items = [
    { key: "total_cases", label: "Rescue Cases Tracked", prefix: "" },
    { key: "active_count", label: "In Our Care Right Now", prefix: "" },
    { key: "recovered_count", label: "Recovered & Released", prefix: "" },
  ];

  return (
    <section className="bg-amtm-bg py-16 md:py-24" data-testid="landing-live-stats">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <Reveal className="text-center mb-12">
          <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.18em] text-amtm-teal mb-4">
            Live Data
          </p>
          <h2 className="font-display text-3xl md:text-4xl text-amtm-text">Our rescue operations, live</h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-10 gap-x-6 text-center">
          {items.map((it, i) => (
            <Reveal key={it.key} delay={i * 0.08}>
              <LiveNumeral target={stats ? stats[it.key] : null} prefix={it.prefix} />
              <p className="text-xs md:text-sm uppercase tracking-wide text-amtm-textMuted mt-3">{it.label}</p>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3} className="text-center mt-12">
          <p className="text-amtm-textMuted text-sm max-w-xl mx-auto">
            Live numbers from our case management platform — every rescue is logged, tracked, and published in real
            time.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
